import { PhoneLoginForm } from '@/Ship/Components/Auth/PhoneLoginForm'

import { FormWrapper } from '../FormWrapper'

/**
 * Вхід на сторінці `/public/login`.
 *
 * Сама форма — Ship `PhoneLoginForm`: та сама потрібна й `templateError403`
 * (`LoginPageTemplate`), а Ship не може імпортувати контейнер.
 */
export const LoginForm = () => (
    <FormWrapper>
        <PhoneLoginForm />
    </FormWrapper>
)
